import Service from '../../services'

// initial state
const state = {

};


// getters
const getters = {

};


// actions
const actions = {

    onGetAllBanners ({ commit }) {
        return Service.banner.getAllBanners();
    },

    onUpdateBanners ({ commit }, data) {
        return Service.banner.updateBanners(data);
    }

};


// mutations
const mutations = {


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
